<!--
// app/components/Shared/landings/BannerJoinTheDraft.vue
-->
<script setup lang="ts">
type Props = {
  leagueLogo: string;
  leagueLogoAlt: string;
  draftFormLink: string;
  claimBeforeButton?: string;
  buttonText?: string;
  onlyMobile?: boolean;
};

defineProps<Props>();
</script>

<template>
  <a :href="draftFormLink" target="_blank" :class="['bg-banner', { 'md:!hidden': onlyMobile }]">
    <img :src="leagueLogo" :alt="leagueLogoAlt" class="w-1/3 max-w-[235px] md:w-auto shrink" />
    <div class="w-2/3 sm:w-1/2 flex flex-col items-center justify-center md:w-auto">
      <p class="mt-4 md:mt-6 !mb-2 text-sm sm:text-base md:text-lg text-center">
        {{ claimBeforeButton ? claimBeforeButton : $t("landing.newRegions.claimBeforeButton") }}
      </p>
      <button
        class="btn btn-emphasis w-full font-['Archivo_Expanded'] uppercase text-center font-bold text-sm leading-none sm:text-lg md:text-xl"
      >
        {{ buttonText ? buttonText : $t("worldCup.draft.title") }}
      </button>
    </div>
  </a>
</template>

<style scoped>
.bg-banner {
  @apply bg-[url('/img/landings/brazil/bg-banner-brazil-mobile.jpg')] bg-cover bg-left-bottom md:bg-right-top w-full;
  @apply max-h-[235px] sm:max-h-none md:rounded-3xl p-4 sm:px-5 md:p-8 flex flex-row gap-3 md:gap-0 md:flex-col items-center;
  @apply justify-between md:justify-center max-w-full;
}
</style>
